var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.resultError.hasMessages())?_c('div',{staticClass:"alert alert-danger"},_vm._l((_vm.resultError.messagesFlattened),function(message){return _c('div',{key:message},[_vm._v(" "+_vm._s(message)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }